<template>
  <div>
    <template v-for="(rule, idx) of rules" v-if="rules && rules.length > 0">
      <div class="a-container-form admin-buy__block" v-if="dateLabel">
        <div class="a-label a-label--w-340">{{dateLabel}}</div>
        <div class="a-form-field"
             :class="{'a-form-field--error': $v.rules.$each[idx].startDate.$anyError}">
          <date-picker v-model="rule.startDate" v-if="canEditRules"></date-picker>
          <date-time :value="rule.startDate" :time="false" v-else></date-time>
        </div>
      </div>

      <div class="admin-buy__block">
        <div class="a-container-form a-width-100-percent u-padding-bottom-0">
          <div class="a-label a-label--w-340">{{partsLabel}}</div>

          <div class="a-flex-start a-align-items-center a-spaces-between a-width-100-percent">

            <div class="a-flex-start a-align-items-center">
              <div class="a-label a-label--auto">{{$t('labels.range-from')}}</div>
              <div class="a-form-field"
                   :class="{'a-form-field--error': $v.rules.$each[idx].$dirty && $v.rules.$each[idx].fromPart.$invalid}">
                <input-number class="a-input a-input--w-80" v-model="rule.fromPart" v-if="canEditRules"></input-number>
                <p v-else>{{rule.fromPart}}</p>
              </div>
            </div>

            <div class="a-flex-start a-align-items-center u-padding-left-20">
              <div class="a-label a-label--auto">{{$t('labels.range-till')}}</div>
              <div class="a-form-field"
                   :class="{'a-form-field--error': $v.rules.$each[idx].$dirty && $v.rules.$each[idx].toPart.$invalid}">
                <input-number class="a-input a-input--w-80" v-model="rule.toPart" v-if="canEditRules"></input-number>
                <p v-else>{{rule.toPart}}</p>
              </div>
            </div>

            <div class="u-padding-left-20 a-width-200 " v-if="canEditRules">
                <button class="gui-btn gui-btn--white-border gui-btn--w-167"
                        @click.prevent="onRemoveRuleClick">
                  {{$t('buttons.delete')}}
                </button>
            </div>
          </div>
        </div>

        <div class="a-container-form u-padding-bottom-0" v-if="hint">
          <div class="a-label a-label--w-340"></div>
          <label class="a-label--w-260">{{hint}}</label>
        </div>
      </div>

      <div class="a-container-form" v-if="idx !== rules.length - 1">
        <div class="a-label a-label--w-340"></div>
        <div class="a-width-100-percent border-bottom"></div>
      </div>

    </template>

    <div class="a-container-form admin-buy__block" v-if="canEditRules">
      <div class="a-label a-label--w-340"></div>
      <div class="admin-buy__block-gui-btn a-width-100-percent a-flex-start">
        <button class="gui-btn gui-btn--red gui-btn--w-167" @click.prevent="rules.push({})">{{$t('buttons.add')}}</button>
        <button class="gui-btn gui-btn--red gui-btn--w-167" @click.prevent="onApplyRulesClick">{{$t('buttons.apply')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { required, between } from '@/validators'
  import PermissionsMixins from '../mixins/permissions';

  export default {
    props: {
      lot: {
        type: Object,
        required: true
      },

      lotRules: {
        type: Array,
        required: true
      },

      hint: {
        type: String
      },

      dateLabel: {
        type: String
      },

      partsLabel: {
        type: String
      }
    },

    mixins: [
      PermissionsMixins
    ],

    data: () => ({
      rules: undefined
    }),

    watch: {
      lotRules: {
        deep: true,
        immediate: true,
        handler: function() {
          let rules = _.cloneDeep(this.lotRules);
          if (rules.length == 0) rules = [{}];
          this.rules = rules;
        }
      }
    },

    computed: {
      canEditRules() {
        return this.canEditFull;
      }
    },

    validations: {
      rules: {
        $each: {
          startDate: {
            valid(value) {
              return !value || value >= new Date;
            }
          },
          fromPart: {
            required,
            between(value) {
              return between(0, this.lot.numberOfParts)(value)
            },
            valid(value, data) {
              return value <= data.toPart
            }
          },

          toPart: {
            required,
            between(value) {
              return between(0, this.lot.numberOfParts)(value)
            },
            valid(value, data) {
              return value >= data.fromPart
            }
          }
        }
      }
    },

    created() {
      this.$v.$touch();
    },

    methods: {
      async onApplyRulesClick() {
        this.$v.$touch();
        if (this.$v.$invalid) return;

        this.$emit('apply', _.cloneDeep(this.rules));
      },

      async onRemoveRuleClick(idx) {
        this.rules.splice(idx, 1);

        this.$v.$touch();
        if (this.$v.$invalid) return;

        this.$emit('apply', _.cloneDeep(this.rules));
      }
    }
  }
</script>

<style scoped>
</style>
